// auto-generated by Typewriter template _models.tst from PortCall.Models\TopicCards\TopicCardTimeEntry.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';


// TopicCardTimeEntryData is the class that TopicCardTimeEntry serializes to/from
export interface TopicCardTimeEntryData {
	
	
    HasTimeEntry : boolean;
    Label : string | null;
    Response : /* ISO8601 */ string | null;
}

// TopicCardTimeEntryOptions is the class which may be passed to the TopicCardTimeEntry constructor to define optional initial data values
export interface TopicCardTimeEntryOptions {
	
	
    HasTimeEntry? : boolean;
    Label? : string | null;
    Response? : /* ISO8601 */ string | null;
}

export class TopicCardTimeEntry {
	
	
    public HasTimeEntry : DataSignal<boolean>;
    public Label : DataSignal<string | null>;
    public Response : DataSignal<TZDate | null>;

    constructor();
    constructor(data : TopicCardTimeEntryOptions);
    constructor(data: TopicCardTimeEntryOptions | null = null) {
	    
	    
        this.HasTimeEntry = jsonableObservable(S.value<boolean>(data && data.HasTimeEntry !== undefined ? data.HasTimeEntry : false));
        this.Label = jsonableObservable(S.value<string | null>(data && data.Label !== undefined ? data.Label : null));
        this.Response = jsonableObservable(S.value<TZDate | null>(data && data.Response !== undefined ? data.Response === null ? null : new TZDate(data.Response) : null, TZDate.nullableEq));
    }

    static key(obj : TopicCardTimeEntry) {
        return ;
    }
    
    static dataKey(obj : TopicCardTimeEntryOptions) {
        return ;
    }

    static update(obj : TopicCardTimeEntry, data : TopicCardTimeEntryOptions) {
        S.freeze(() => {
	        
	        
            if (data.HasTimeEntry !== undefined) obj.HasTimeEntry(data.HasTimeEntry);
            if (data.Label !== undefined) obj.Label(data.Label);
            if (data.Response !== undefined) obj.Response(data.Response === null ? null : new TZDate(data.Response));
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/TopicCardTimeEntry.ts